import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button, LinearProgress } from '@material-ui/core'
import axios from 'axios'

export default function UploadEmployees(props) {
    const [selectedFile, setSelectedFile] = useState(false)
    const [errorMessage, setErrorMessage] = useState(false)
    const [uploadingInProgress, setUploadingInProgress] = useState(false)
    const [progressPercentage, setProgressPercentage] = useState(0)
    const dataProccess = useRef(null)

    const uploadFile = () => {
        console.log('upload file clicked')
        setUploadingInProgress(true)
        const data = new FormData()
        const dataProccessing = setInterval(() => {
            dataProccess.current = dataProccess.current + 2
            setProgressPercentage(dataProccess.current)
        }, 2000)
        data.append('media_file', selectedFile)
        axios.post('/api/employees/upload', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function( progressEvent ) {
                dataProccess.current = (parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) - 30 ))
                setProgressPercentage(dataProccess.current)
            },
          }).then(res => {
            setUploadingInProgress(false)
            clearInterval(dataProccessing)
            if(res.data.status) {
                props.onEmployeesUpload()
                localStorage.removeItem('reportData')
            } else {
                setErrorMessage('Sorry, we are unable to process your file.')
            }
        })
    }
    

    return (
        <>
            <Typography gutterBottom display='inline' color='textSecondary' >
                Please make sure that you are going to upload filled template
                file. If not then please download the template file first.
            </Typography>
            <Button size="small" onClick={() => props.onDownloadTemplate()} color='primary'>
                (Download Template)
            </Button>
            <Box m={2} display="flex" justifyContent="center">
            </Box>
            <Typography variant='h4' gutterBottom>Select Filled Template File(xlsx) to upload Employees</Typography>
            <Typography color='error'>{errorMessage}</Typography>
            <Box m={2} display="flex" justifyContent="center">
                <input
                    type="file"
                    className="custom-file-input"
                    id="inputGroupFile01"
                    aria-describedby="inputGroupFileAddon01"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                />
            </Box>
            <Box m={2} display="flex" justifyContent="center">
                <Button
                    variant="contained"
                    onClick={uploadFile}
                    disabled={!selectedFile || uploadingInProgress}
                >
                    Upload
                </Button>
            </Box>
            <Box m={2} display="flex" justifyContent="center">
                {uploadingInProgress ? <span>Uploading...</span> : null }
            </Box>
            {uploadingInProgress && 
            <LinearProgress variant="determinate" value={progressPercentage} /> }
        </>
    )
}

UploadEmployees.propTypes = {
    onEmployeesUpload: PropTypes.func.isRequired,
    onDownloadTemplate: PropTypes.func.isRequired,
}
